import React, { Component } from 'react';
import Login from '../../Components/Auth/Login';
import { connect } from 'react-redux';
import { loginUser } from '../../Store/Actions/LoginActions';
import './Login.css';

class LoginPage extends Component {
	render() {
		return (
			<div>
				<div className="LoginWrapper">
					<div className="LoginFormWrapper">
					</div>
				</div>
				<div className="formWrapper">				
					<Login onLoginClick={this.props.loginTheUser} errorMessage={this.props.errorMessage} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		schedule: state.schedulePage,
		roomTypes: state.roomTypes.data,
		resources: state.assets.data,
		buildings: state.buildings.data,
		floors: state.floors.data,
		rooms: state.rooms.data,
		errorMessage: state.auth.errorMessage
	
	};

};

const mapDispatchtoProps = (dispatch) => {
	return {
		// scheduleFetch: () => dispatch(scheduleFetchData()),
		// buildingsFetch: () => dispatch(getAll('buildings', {})),
		// floorsFetch: () => dispatch(getAll('floors', {})),
		// roomTypeFetch: () => dispatch(getAll('roomtypes', {})),
		// roomsFetch: () => dispatch(getAll('rooms', {}))
		loginTheUser: (creds) => dispatch(loginUser(creds))
	};
};
export default connect(mapStateToProps, mapDispatchtoProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/Pages/Login/Login.js